import { setContext } from '@apollo/client/link/context';

import { AuthState } from 'contexts/Auth';
import { setAuthHeader } from 'util/authHeader';

import apolloClient from '.';
import Link from './link';

const addAuthHeaderInGraph = (auth: AuthState) => {
  const contextLink = setContext((_, { headers }) => ({
    headers: setAuthHeader(headers, auth),
  }));

  apolloClient.setLink(contextLink.concat(Link));
};

export default addAuthHeaderInGraph;
